export default __webpack_public_path__ + "static/media/BackupValidataionStatus02-Oracle.690153d7.png";